import React from 'react';
import {getLanguage} from "./source/js/common";
const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

class NoPermission extends React.Component {
    render() {
        return (
            <div >
                {commonLan.noPermission}
            </div>
        );
    }
}
export default NoPermission;
